import NoPaymentImage from '../images/nopayment@3x.png';
import { Box, Image, Text } from '@zillow/constellation-10';

export type BillingEmptyBannerProps = {
  notification: {
    title: string;
    text: Array<string>;
  };
};

const BillingEmptyBanner = ({ notification }: BillingEmptyBannerProps) => (
  <Box css={{ marginBlock: 'xl', marginInline: 'xl' }}>
    <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Image src={NoPaymentImage} alt="No Payments" css={{ height: '100px' }} />
      <Text textStyle="heading-sm">{notification.title}</Text>
      {notification.text.map((text, i) => (
        <Text key={i}>{text}</Text>
      ))}
    </Box>
  </Box>
);

export default BillingEmptyBanner;
